import type { ReactNode } from 'react';

export const symbol_phishing: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M270-190q-70-70-70-170v-180q0-10 9.5-13.5T226-550l129 129q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9l-52-52v71q0 75 52.5 127.5T440-180q75 0 127.5-52.5T620-360v-134q-35-11-57.5-40T540-600q0-37 22.5-66t57.5-40v-144q0-13 8.5-21.5T650-880q13 0 21.5 8.5T680-850v144q35 11 57.5 40t22.5 66q0 37-22.5 66.5T680-494v134q0 100-70 170t-170 70q-100 0-170-70Zm415.5-374.5Q700-579 700-600t-14.5-35.5Q671-650 650-650t-35.5 14.5Q600-621 600-600t14.5 35.5Q629-550 650-550t35.5-14.5ZM650-600Z"
		/>
	</svg>
);
